export default __webpack_public_path__ + "static/media/link expire.06f96d63.png";